export const mockEvent = (value) => ({ target: { value } })
